export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const OAUTH_PROVIDER_URL = process.env.REACT_APP_OAUTH_PROVIDER_URL;
export const OAUTH_PROVIDER_REALM = process.env.REACT_APP_OAUTH_PROVIDER_REALM;
export const OAUTH_PROVIDER_CLIENT_ID =
  process.env.REACT_APP_OAUTH_PROVIDER_CLIENT_ID;
export const MDM_WELCOME_VIDEO_URL =
  process.env.REACT_APP_MDM_WELCOME_VIDEO_URL;
